export const MARATHONS_SET_TAB_INDEX = 'MARATHONS_SET_TAB_INDEX';
export const MARATHONS_SET_PAGE_NUM = 'MARATHONS_SET_PAGE_NUM';
export const MARATHONS_SET_COURSES = 'MARATHONS_SET_COURSES';
export const MARATHONS_SET_COURSES_IS_LOADING = 'MARATHONS_SET_COURSES_IS_LOADING';
export const MARATHONS_SET_STOP_LOADING = 'MARATHONS_SET_STOP_LOADING';
export const MARATHONS_RESET_TAB_PAGE_AND_COURSES = 'MARATHONS_RESET_TAB_PAGE_AND_COURSES';
export const MARATHONS_CLEAR_COURSES_AND_PAGE_NUM = 'MARATHONS_CLEAR_COURSES_AND_PAGE_NUM';
export const MARATHONS_UPDATE_MARATHON = 'MARATHONS_UPDATE_MARATHON';
